// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59c59470","239":"6f9ac20a","455":"d8913f51"}[chunkId] + ".chunk.js";
};